import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import { RenderFunc } from '../types/RenderFunc';

export const renderApproveDocumentsDate: RenderFunc = item => {
  const { newValue, oldValue } = item;
  const stringOldValue = typeof oldValue === 'string' ? oldValue : '';
  const stringNewValue = typeof newValue === 'string' ? newValue : '';

  return {
    renderedOldValue: `Дата приказа руководителя ${formatDate({
      date: stringOldValue,
      dateFormat: DATE_FORMAT_LONG_FNS,
    })}`,
    renderedNewValue: `Дата приказа руководителя ${formatDate({
      date: stringNewValue,
      dateFormat: DATE_FORMAT_LONG_FNS,
    })}`,
  };
};
